module.exports = __webpack_public_path__ + "static/media/dan.be851da8.svg";